import bdiQuestions from './bdi/questions.json';
import bdiConfig from './bdi/config.json';
import baiQuestions from './bai/questions.json';
import baiConfig from './bai/config.json';
import ybocsQuestions from './ybocs/questions.json';
import ybocsConfig from './ybocs/config.json';
import mdqQuestions from './mdq/questions.json';
import mdqConfig from './mdq/config.json';
import bsdsQuestions from './bsds/questions.json';
import bsdsConfig from './bsds/config.json';
import asrsQuestions from './asrs/questions.json';
import asrsConfig from './asrs/config.json';
import ymrsQuestions from './ymrs/questions.json';
import ymrsConfig from './ymrs/config.json';
import panssQuestions from './panss/questions.json';
import panssConfig from './panss/config.json';
import caps5Questions from './caps5/questions.json';
import caps5Config from './caps5/config.json';
import isaaQuestions from './isaa/questions.json';
import isaaConfig from './isaa/config.json';
import pid5Questions from './pid5/questions.json';
import pid5Config from './pid5/config.json';
import caarsQuestions from './caars/questions.json';
import caarsConfig from './caars/config.json';
import bprsQuestions from './bprs/questions.json';
import bprsConfig from './bprs/config.json';
import pcptsd5Questions from './pcptsd5/questions.json';
import pcptsd5Config from './pcptsd5/config.json';
import igds9sfQuestions from './igds9sf/questions.json';
import igds9sfConfig from './igds9sf/config.json';
import iatQuestions from './iat/questions.json';
import iatConfig from './iat/config.json';
import cprsQuestions from './cprs/questions.json';
import cprsConfig from './cprs/config.json';
import ctrsQuestions from './ctrs/questions.json';
import ctrsConfig from './ctrs/config.json';
import assistQuestions from './assist/questions.json';
import assistConfig from './assist/config.json';

const testData = {
  BDI: { questions: bdiQuestions, config: bdiConfig },
  BAI: { questions: baiQuestions, config: baiConfig },
  YBOCS: { questions: ybocsQuestions, config: ybocsConfig },
  MDQ: { questions: mdqQuestions, config: mdqConfig },
  BSDS: { questions: bsdsQuestions, config: bsdsConfig },
  ASRS: { questions: asrsQuestions, config: asrsConfig },
  YMRS: { questions: ymrsQuestions, config: ymrsConfig },
  PANSS: { questions: panssQuestions, config: panssConfig },
  CAPS5: { questions: caps5Questions, config: caps5Config },
  ISAA: { questions: isaaQuestions, config: isaaConfig },
  PID5: { questions: pid5Questions, config: pid5Config },
  CAARS: { questions: caarsQuestions, config: caarsConfig },
  BPRS: { questions: bprsQuestions, config: bprsConfig },
  PCPTSD5: { questions: pcptsd5Questions, config: pcptsd5Config },
  IGDS9SF: { questions: igds9sfQuestions, config: igds9sfConfig },
  IAT: { questions: iatQuestions, config: iatConfig },
  CPRS: { questions: cprsQuestions, config: cprsConfig },
  CTRS: { questions: ctrsQuestions, config: ctrsConfig },
  ASSIST: { questions: assistQuestions, config: assistConfig },
};

export const getTestQuestions = (testType) => {
  return testData[testType]?.questions || bdiQuestions;
};

export const getTestConfig = (testType) => {
  return testData[testType]?.config || bdiConfig;
};

export const getTestMetadata = (testType) => {
  const data = getTestQuestions(testType);
  return {
    testCode: data.testCode,
    testName: data.testName,
    version: data.version,
    questionCount: data.questionCount,
  };
};
